'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var PropTypes$1 = _interopDefault(require('prop-types'));
var styled = require('styled-components');
var styled__default = _interopDefault(styled);
var _babelHelpers = require('../_babelHelpers-48e7a7f7.js');
var settings = require('../settings-9ee2f03f.js');
require('../style-222d2b0f.js');
var b16 = require('../typography/b16.js');

var _templateObject = _babelHelpers.taggedTemplateLiteral(["\n  padding: ", ";\n  height: ", ";\n  ", ";\n  border-radius: 5px;\n  background-color: ", ";\n  border: solid 1px ", ";\n  color: ", ";\n  overflow-y: auto;\n  @media (max-width: 767px) {\n    overflow: ", ";\n    height: ", ";\n    padding: ", ";\n    position: relative;\n  }\n"], ["\n  padding: ", ";\n  height: ", ";\n  ", ";\n  border-radius: 5px;\n  background-color: ", ";\n  border: solid 1px ", ";\n  color: ", ";\n  overflow-y: auto;\n  @media (max-width: 767px) {\n    overflow: ", ";\n    height: ", ";\n    padding: ", ";\n    position: relative;\n  }\n"]),
    _templateObject2 = _babelHelpers.taggedTemplateLiteral(["\n  display: none;\n  @media (max-width: 767px) {\n    padding: ", ";\n    display: flex;\n    box-sizing: border-box;\n    align-items: flex-end;\n    position: absolute;\n    border-radius: 5px;\n    width: 100%;\n    height: 100%;\n    top: 0;\n    left: 0;\n    background-image: linear-gradient(\n      to bottom,\n      rgba(249, 249, 249, 0),\n      #f1f1f1\n    );\n  }\n"], ["\n  display: none;\n  @media (max-width: 767px) {\n    padding: ", ";\n    display: flex;\n    box-sizing: border-box;\n    align-items: flex-end;\n    position: absolute;\n    border-radius: 5px;\n    width: 100%;\n    height: 100%;\n    top: 0;\n    left: 0;\n    background-image: linear-gradient(\n      to bottom,\n      rgba(249, 249, 249, 0),\n      #f1f1f1\n    );\n  }\n"]);
var StyledScrollTextBox = styled__default.div(_templateObject, function (props) {
  return props.padding ? "" + props.padding : "21px 26px";
}, function (props) {
  return props.height ? "" + props.height + (props.heightWithUnit ? "" : "px") : "auto";
}, function (props) {
  return props.maxHeight && "max-height: " + props.maxHeight;
}, settings.COLOR.veryLightGray, settings.COLOR.lineGray, settings.COLOR.darkGray, function (props) {
  return props.hideOverlay ? "auto" : "hidden";
}, function (props) {
  return props.mHeight ? props.mHeight : "284px";
}, function (props) {
  return props.mPadding ? "" + props.mPadding : "21px 26px";
});

var TermOverlay = styled__default.div(_templateObject2, function (props) {
  return props.mPadding ? "" + props.mPadding : "15px 26px";
});

var TermBox = function TermBox(_ref) {
  var children = _ref.children,
      overlayText = _ref.overlayText,
      onClickOverlay = _ref.onClickOverlay,
      hideOverlay = _ref.hideOverlay,
      rest = _babelHelpers.objectWithoutProperties(_ref, ["children", "overlayText", "onClickOverlay", "hideOverlay"]);
  return React__default.createElement(
    StyledScrollTextBox,
    _babelHelpers._extends({ hideOverlay: hideOverlay }, rest),
    !hideOverlay && React__default.createElement(
      TermOverlay,
      { onClick: onClickOverlay, mPadding: rest.mPadding },
      React__default.createElement(
        b16.default,
        { color: settings.COLOR.deepBlue, margin: "0" },
        overlayText
      )
    ),
    children
  );
};

TermBox.propTypes = {
  /** height for term box */
  height: PropTypes$1.string,
  /** height for term box in mobile */
  mHeight: PropTypes$1.string,
  /** max-height for term box in mobile */
  maxHeight: PropTypes$1.string,
  /** text for overlay box */
  overlayText: PropTypes$1.string,
  /** hide overlay box */
  hideOverlay: PropTypes$1.bool,
  /** on click function for overlay component */
  onClickOverlay: PropTypes$1.func
};
TermBox.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "TermBox",
  "props": {
    "height": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "height for term box"
    },
    "mHeight": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "height for term box in mobile"
    },
    "maxHeight": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "max-height for term box in mobile"
    },
    "overlayText": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "text for overlay box"
    },
    "hideOverlay": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "hide overlay box"
    },
    "onClickOverlay": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "on click function for overlay component"
    }
  }
};

exports.StyledScrollTextBox = StyledScrollTextBox;
exports.TermOverlay = TermOverlay;
exports.default = TermBox;
//# sourceMappingURL=box.js.map
